import { useState, useEffect } from 'react';

const useOffsetSize = (targetRef, ...props) => {
  const [offsetSize, setOffsetSize] = useState({ left: 0, top: 0, width: 0, height: 0 });

  useEffect(() => {
    if (targetRef === null || targetRef.current === null) {
      return;
    }

    setOffsetSize({
      left: targetRef.current.offsetLeft,
      top: targetRef.current.offsetTop,
      width: targetRef.current.offsetWidth,
      height: targetRef.current.offsetHeight,
    });
  }, [targetRef, ...props]);

  return offsetSize;
};

export default useOffsetSize;
